(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/views/correct-row.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/views/correct-row.js'); 
'use strict';

svs.sport.result_boxes.views.MyBetCorrectRow = Backbone.Marionette.View.extend(
  {
    className: 'maltipset-best-rows',
    model: svs.sport.result_boxes.models.CorrectRow,
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.sport.result_boxes.templates.correct_row(data);
    }
  }
);

 })(window);